import React, { Component, ReactNode } from 'react'

interface State {
  hasError: boolean
  error: Error | null
}

interface Props {
  children: ReactNode
}

class NetworkErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    // 检查是否是网络相关错误
    if (
      error.message.includes('underlying network changed') ||
      error.message.includes('NETWORK_ERROR') ||
      (error as any).code === 'NETWORK_ERROR'
    ) {
      console.debug('Network error caught by boundary:', error)
      // 网络错误不显示错误页面，直接忽略
      return { hasError: false, error: null }
    }

    // 其他错误正常处理
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: any) {
    // 网络错误不记录
    if (
      error.message.includes('underlying network changed') ||
      error.message.includes('NETWORK_ERROR') ||
      (error as any).code === 'NETWORK_ERROR'
    ) {
      console.debug('Network error ignored by boundary:', error)
      return
    }

    console.error('Error caught by boundary:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h2>Something went wrong</h2>
          <p>Please refresh the page and try again.</p>
          <button onClick={() => window.location.reload()}>Refresh</button>
        </div>
      )
    }

    return this.props.children
  }
}

export default NetworkErrorBoundary
